import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const Container = lib.styled.div`
  overflow: auto;
  height: 100%;
  background-color: #FFF;
  padding-left: 15px;
  padding-right: 15px;
  outline: none;
  padding: 0px 10px 0px 15px;
  overflow: -moz-scrollbars-none!important;
  -ms-overflow-style: none!important;
  display: flex;

  .list-container {
    margin-top: 0px!important;

    [data-index="${props => props.listItemsCount}"] {
      padding-bottom: 50px !important;
    }

    div {
      div:first-child {
        margin-top: 0px;
      }
    }
  }

  &::-webkit-scrollbar { width: 0!important; display: none!important;  }
`;

export const BoxAlphabetic = lib.styled.div`
  width: 20px;
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 999;
  margin-left: 5px;

  span {
    cursor: pointer;
    padding-bottom: 6px;
    font-size: 9px;
    color: ${colors.black};
    opacity: 0.6;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;

    &:hover {
      color: ${colors.lightBlue};
    }
  }
`;

export const Header = lib.styled.span`
  display: flex;
  flex: 1;
  background-color: ${colors.white};
  height: 40px;
  font-size: 13px;
  color: ${colors.black};
  align-items: center;
`;
